import { BillingItemResource } from '../../../Entities/BillingItem';
import { idFrom } from '../../../utils';
import { PAYMENT_REJECTED, PAYMENT_SUCCEEDED } from '../utils';

export default function validateBillingItems(
  billingItems: BillingItemResource[],
): undefined | string[] {
  const errors: string[] = [];

  errors.concat(validateAtLeastOneBillingItemSelected(billingItems) ?? []);
  errors.concat(validateAllBillingItemsAreNotPaidOrRejected(billingItems) ?? []);
  errors.concat(validateAllBillingItemsAreSameMerchant(billingItems) ?? []);

  if (errors.length > 0) {
    return errors;
  }
}

function validateAtLeastOneBillingItemSelected(
  billingItems: BillingItemResource[],
): undefined | string[] {
  if (billingItems.length === 0) {
    return ['At least one billing item must be selected'];
  }
}

function validateAllBillingItemsAreNotPaidOrRejected(
  billingItems: BillingItemResource[],
): undefined | string[] {
  const hasPaidOrRejected = billingItems.some(
    (bi) =>
      idFrom(bi, 'billing_item_status') === PAYMENT_SUCCEEDED ||
      idFrom(bi, 'billing_item_status') === PAYMENT_REJECTED,
  );

  if (hasPaidOrRejected) {
    return ['Cannot charge payment for billing items that have already been paid or rejected.'];
  }
}

function validateAllBillingItemsAreSameMerchant(
  billingItems: BillingItemResource[],
): undefined | string[] {
  const merchantIds = billingItems.map((item) => idFrom(item, 'merchant'));
  const merchantId = merchantIds.length > 0 ? merchantIds[0] : undefined;

  if (!merchantIds.every((id) => id === merchantId)) {
    return ['All billing items must belong to the same merchant'];
  }
}
